// extracted by mini-css-extract-plugin
export var content = "_pg-1";
export var fullScreen = "_pg-0";